import {useState} from "react";
import {useForm} from "antd/es/form/Form";
import {PublicInformationItem} from "../types/pyblicInformation";
import {openSuccessNotification, showErrorNotification} from "../helpers/mainHelpers";
import {publicInformationService} from "../services/publicInfo-service";
import {Modal} from "antd";
import {DeleteOutlined} from "@ant-design/icons";

export const usePublicInformationController = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [publicInfoItemsList, setPublicInfoItemsList] = useState<PublicInformationItem[]>([])
  const [selectedPublicInfoItem, setSelectedPublicInfoItem] = useState<PublicInformationItem | null>(null)
  const [lastUpdate, setLastUpdate] = useState(0)
  const [form] = useForm()


  const toggleModal = () => {
    const newValue = !isModalOpen
    setIsModalOpen(newValue)
    if (newValue === false) {
      form.resetFields()
      setSelectedPublicInfoItem(null)
    }
  }
  const toggleLastUpdate = () => {
    setLastUpdate(Date.now())
  }

  const getPublicInfoItemData = async (id: string) => {
    setIsLoading(true)
    try {
      const data = await publicInformationService.getById(id)
      setSelectedPublicInfoItem(data)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка при завантаженні публічної інформації!"})
    } finally {
      setIsLoading(false)
    }
  }

  const fetchPublicInfoItemsList = async (queries: string[]) => {
    setIsLoading(true)
    try {
      const list = await publicInformationService.list(queries)
      setPublicInfoItemsList(list)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка при отриманні публічної інформації!"})
    } finally {
      setIsLoading(false)
    }
  }
  const confirmDeletePublicInfoItem = (id: string) => {
    const {confirm} = Modal;
    confirm(
      {
        width: 400,
        icon: <DeleteOutlined/>,
        title: `Видалити запис публічної інформації?`,
        okText: "Видалити",
        okButtonProps: {danger: true},
        cancelText: "Cкасувати",
        onOk: async () => {
          await deletePublicInfoItemHandler(id)
        },
      });
  }

  const deletePublicInfoItemHandler = async (id: string) => {
    setIsLoading(true)
    try {
      await publicInformationService.delete(id)
      openSuccessNotification("Запис успішно видалено!")
      toggleLastUpdate()
    } catch (error) {
      showErrorNotification({
        message: "Помилка видалення запису публічної інформації!",
        description: JSON.stringify(error)
      });
    } finally {
      setIsLoading(false)
    }
  }


  const createPublicInformationItem = async (data: PublicInformationItem) => {
    setIsLoading(true)
    try {
      const createdOffice = await publicInformationService.create(data)
      openSuccessNotification("Публічну інформацію успішно додано!")
      toggleModal()
      toggleLastUpdate()
    } catch (error) {
      showErrorNotification({message: "Помилка додавання публічної інформації", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }
  const updatePublicInformationItem = async (data: PublicInformationItem) => {
    setIsLoading(true)
    try {
      const updatedItem = await publicInformationService.update(data)
      toggleModal()
      toggleLastUpdate()
      openSuccessNotification("Публічну інформацію успішно оновлено!")
    } catch (error) {
      showErrorNotification({message: "Помилка оновлення публічної інформації", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }

  const submitButtonHandler = async (formData: { title: string, fileLink: string }) => {
    if (selectedPublicInfoItem) {
      await updatePublicInformationItem({...formData, $id: selectedPublicInfoItem?.$id || ""})
    } else {
      await createPublicInformationItem(formData)
    }
  }

  const editButtonHandler = (selectedItem: PublicInformationItem) => {
    setSelectedPublicInfoItem(selectedItem)
    toggleModal()
  }


  return {
    form,
    isLoading,
    isModalOpen,
    selectedPublicInfoItem,
    toggleModal,
    submitButtonHandler,
    publicInfoItemsList,
    lastUpdate,
    fetchPublicInfoItemsList,
    confirmDeletePublicInfoItem,
    editButtonHandler,
    getPublicInfoItemData
  }

}